/* =========================

  which is name

============================ */
import styled from "styled-components";
import {break_point_sp} from "../../../Styled/mixin";
import {opacity_default} from "../../../Styled/mixin";

import { useSelector,useDispatch } from "react-redux";


/* -------------------------

  component

---------------------------- */
function Start( props ) {
  const count = useSelector((state)=>state.count);
  const dispatch = useDispatch();

  const doAction = (e) => {
    e.preventDefault();

    e.currentTarget.closest(`#start`).classList.add("isFadeOut");
    e.currentTarget.closest(`#start`).classList.add("isDisplayNone");
    dispatch({type:"ADD_COUNT",payload:count + 1});
  }

  return (
    <>
    <Styled id="btn_start" className="c-font_f--km">
      <div className="c-btn_start">
        <div className="c-btn_start__inner">
          <div className="c-btn_start__btn" onClick={doAction}>
            <p className="c-btn_start__txt--balloon">無料</p>
            <p className="c-btn_start__txt">{props.children}</p>
          </div>
        </div>
      </div>
    </Styled>
    </>
  );
}

export default Start;

/* -------------------------

  styled

---------------------------- */
const Styled = styled.div`
  .c-btn_start {
    width: fit-content;
    .c-btn_start__inner {
      padding: 20px 0 0 0;
    }
    .c-btn_start__btn {
      position: relative;
      min-width: 480px;
      padding: 26px 120px;
      background-color: #ee7300;
      border-radius: 50vw;
      cursor: pointer;
      /* ホバー時 */
      &:hover {
        opacity: 0.8;
      }
      // 矢印アイコン
      &::after {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 60px;
        z-index: 2;
        content: "";
        display: block;
        width: 33px;
        height: 32px;
        background-image: url(${process.env.PUBLIC_URL}/assets/img/top/c-btn_start-img01.png);
        background-size: 100% auto;
      }
      .c-btn_start__txt {
        color: #ffffff;
        font-size: 3.4rem;
        font-weight: bold;
        text-align: center;
        line-height: 1;
      }
      // 吹き出し
      .c-btn_start__txt--balloon {
        position: absolute;
        top: -20px;
        left: 26px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 90px;
        height: 90px;
        background-color: #ffffff;
        border: 2px solid #ee7300;
        border-radius: 50vw;
        color: #451700;
        font-size: 2.9rem;
        font-weight: 500;
        line-height: 1;
        &::before {
          position: absolute;
          bottom: 17px;
          right: -2px;
          z-index: 2;
          content: "";
          display: block;
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 15px 0 0 15px;
          border-color: transparent transparent transparent #ffffff;
          line-height: 0px;
        }
      }
    }
  }

	@media ${break_point_sp} {
    .c-btn_start {
      width: 100%;
      .c-btn_start__inner {
        padding: 20px 0 0 0;
      }
      .c-btn_start__btn {
        position: relative;
        min-width: 100%;
        width: 100%;
        padding: calc(46 / 750 * 100vw) calc(40 / 750 * 100vw);
        background-color: #ee7300;
        border-radius: 50vw;
        cursor: pointer;
        /* ホバー時 */
        &:hover {
          ${opacity_default}
        }
        // 矢印アイコン
        &::after {
          right: calc(70 / 750 * 100vw);
        }
        .c-btn_start__txt {
          font-size: calc(45 / 750 * 100vw);
        }
        // 吹き出し
        .c-btn_start__txt--balloon {
          top: calc((20 / 750 * 100vw) * -1);
          left: calc(20 / 750 * 100vw);
          width: calc(110 / 750 * 100vw);
          height: calc(110 / 750 * 100vw);
          font-size: calc(38.5 / 750 * 100vw);
          &::before {
            bottom: 10%;
            right: -2%;
          }
        }
      }
    }
  }
`;
